<router-outlet></router-outlet>
<notification></notification>
<toaster></toaster>
<app-component-loader></app-component-loader>
